var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.186,46h-16.79V32.19c0-1.104-0.896-2-2-2H38.605c-1.104,0-2,0.896-2,2V46H19.814c-1.104,0-2,0.896-2,2v15.81 c0,1.104,0.896,2,2,2h56.371c1.104,0,2-0.896,2-2V48C78.186,46.896,77.29,46,76.186,46z M74.186,61.81H21.814V50h16.791 c1.104,0,2-0.896,2-2V34.19h14.791V48c0,1.104,0.896,2,2,2h16.79V61.81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.884292f789c84ad3979745fef20d7e4b.svg";
export { ForwardRef as ReactComponent };